import type { SelectedFile } from '@witmetrics/utils';
import FileCategoryIcon from '@/components/FileCategoryIcon';
import { classes } from './utils';

export type ItemImageProps = {
  selectedFile: SelectedFile;
};

export default function ItemImage({ selectedFile }: ItemImageProps) {
  return selectedFile.previewSource ? (
    <div className={classes.imgWrapper}>
      <img
        className={classes.img}
        alt={selectedFile.file.name}
        src={selectedFile.previewSource}
      />
    </div>
  ) : (
    <FileCategoryIcon
      file={{ name: selectedFile.file.name, fileTypeId: null }}
    />
  );
}
